'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const communityServices: { label: string; href?: string }[] = [
  { label: "Dhangar Vadhu Var" },
  { label: "Dhangar Vadhu List" },
  { label: "Dhangar Vadhu List girl photo" },
  { label: "Dhangar Vadhu in Parbhani" },
  { label: "Dhangar Vadhu Var Whatsapp Group" },
  { label: "Dhangar Vadhu Var Whatsapp Group Link" },
  { label: "Dhangar Vadhu Var Suchak Kendra" },
  { label: "Dhangar Vadhu Var Suchak Mandal Sangli" },
  { label: "Dhangar Vadhu Var Suchak Mandal Mumbai" },
  { label: "Dhangar Caste Category" },
  { label: "Dhangar Vadhu Var Suchak Whatsapp Group" },
  { label: "Dhangar Vadhu Var Suchak Solapur" },
  { label: "Dhangar Vadhu Biodata Photo" },
  { label: "धनगर वधू वर सुचक" },
  { label: "Dhangar Matrimony Maharashtra" },
  { label: "Dhangar Matrimony Whatsapp Group" },
  { label: "Dhangar Marriage" },
  { label: "Dhangar Mahamandal" },
  { label: "Dhangar Grooms" },
  { label: "Dhangar Grooms Maharashtra" },
  { label: "Dhangar Group" },
  { label: "Dhangar Grooms Nashik" },
  { label: "Dhangar Divorced Grooms" },
  { label: "Dhangar Whatsapp Group Link" },
  { label: "Dhangar Samaj Group" },
  { label: "Dhangar Whatsapp Group" },
  { label: "Dhangar Var Grooms" },
  { label: "CA Dhangar Grooms" },
  { label: "Dhangar Brides" },
  { label: "Dhangar Brides Solapur" },
  { label: "Dhangar Brides in Mumbai" },
  { label: "Dhangar Brides in USA" },
  { label: "Dhangar Brides List Pag3" },
  { label: "Dhangar Divorced Brides" },
  { label: "Dhangar Doctor Brides" },
  { label: "Dhangar Divorced Brides photos" },
  { label: "Dhangar Hatkar Brides" },
  { label: "Khutekar Dhangar Brides" },
  { label: "Dhangar Var Vadhu" },
  { label: "Dhangar Var List Hatkar" },
  { label: "धनगर वर्ग" },
  { label: "Dhangar Varn" },
  { label: "Dhangar Var" },
  { label: "Dhangar Var List" },
  { label: "Dhangar Var Grooms" },
  { label: "धनगर समाजाचे आडनाव" },
  { label: "धनगर" },
  { label: "समाज इतिहास" },
  { label: "धनगर समाज" },
  { label: "धनगर समाज वधू वर मेळावा" },
  { label: "धनगर समाजाचे कुलदैवत" },
  { label: "धनगर समाज लोकसंख्या महाराष्ट्र" },
  { label: "धनगर समाज गोत्र" },
  { label: "Dhangar Samaj Matrimony" },
  { label: "Dhangar Samaj Whatsapp Group Link" },
  { label: "Dhangar Matrimony Login" },
  { label: "Dhangar Matrimony Pune" },
  { label: "Dhangar Matrimony Brides" },
  { label: "Dhangar Matrimony Grooms" },
  { label: "Dhangar Matrimony Pune Girl" },
  { label: "Dhangar Matrimony App" },
  { label: "Dhangar Matrimony Brides Photos" },
  { label: "Dhangar Vadhu Var Suchak Mandal Kolhapur" },
  { label: "Dhangar Vadhu Var Suchak Mandal Satara" },
];

export default function DhangarMatrimony() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="धनगर समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="dhangar_matrimony"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "How to find Dhangar Var list Hatkar online?",
                  answer: "Visit trusted MarathiVadhuVarSuchak.com site to search Dhangar Var list Hatkar online."
                },
                {
                  question: "How to search Dhangar matrimony brides list online?",
                  answer: "Dhangar Samaj Vadhu Var can search Dhangar matrimony brides list online through MarathiVadhuVarSuchak.com site."
                },
                {
                  question: "How to join Dhangar matrimony whatsapp group?",
                  answer: "No! Due to privacy policy MarathiVadhuVarSuchak.com site do not have any whatsapp group to join."
                },
                {
                  question: "How to search Dhangar matrimony photos online for free?",
                  answer: "Dhangar Samaj Vadhu Var needs to register free through MarathiVadhuVarSuchak.com site. Then after verification and approval you can search Dhangar Vadhu Var profiles with photos."
                },
                {
                  question: "How to search the Dhangar matrimony grooms online?",
                  answer: "Dhangar brides can register free on MarathiVadhuVarSuchak.com site to search Dhangar grooms online."
                },
                {
                  question: "How to do Dhangar matrimony login online?",
                  answer: "Before login, Dhangar Samaj Vadhu Var first needs to register free through MarathiVadhuVarSuchak.com site. After profile verification you can login anytime online."
                },
                {
                  question: "Which is the best Dhangar matrimony in Pune?",
                  answer: "MarathiVadhuVarSuchak.com is the best Dhangar matrimony for Vadhu Var staying at Pune."
                },
                {
                  question: "How to search for Dhangar brides in Mumbai?",
                  answer: "Visit MarathiVadhuVarSuchak.com for free registration. After profile approval Dhangar community grooms can search for Dhangar brides from Mumbai city."
                },
                {
                  question: "Which is the best Dhangar matrimony app in Maharashtra?",
                  answer: "MarathiVadhuVarSuchak.com is the best Dhangar matrimony app for Vadhu Var for free registration."
                },
                {
                  question: "What are the services offered by Dhangar Vadhu Var?",
                  answer: "MarathiVadhuVarSuchak.com offers free registration for Dhangar Samaj Vadhu Var. Free search, profiles shortlist, sending Interest and profile likes are the free features members can use."
                },
                {
                  question: "What is the Dhangar Vadhu Var Suchak whatsapp number to join?",
                  answer: "No! Because of privacy rights of the members, MarathiVadhuVarSuchak.com does not have any whatsapp group to join."
                },
                {
                  question: "How to join Dhangar Vadhu Var Suchak whatsapp group link?",
                  answer: "Due to privacy policy, MarathiVadhuVarSuchak.com does not provide any link for whatsapp group."
                },
                {
                  question: "How to search Dhangar Vadhu Var Suchak photos?",
                  answer: "To search Dhangar Vadhu Var Suchak photos, first you need to register free through MarathiVadhuVarSuchak.com Marathi matrimony."
                },
                {
                  question: "Where to find Dhangar Vadhu Var Suchak contact number?",
                  answer: "Visit MarathiVadhuVarSuchak.com Marathi matrimony to find Dhangar Vadhu Var Suchak contact number."
                },
                {
                  question: "How to search Khutekar Dhangar Vadhu Var online?",
                  answer: "To search Khutekar Dhangar Vadhu Var online, Dhangar community Grooms and brides first need to register free on MarathiVadhuVarSuchak.com Marathi matrimony."
                },
                {
                  question: "How to search Dhangar Vadhu Var photos with profile?",
                  answer: "To search Dhangar Vadhu Var photos with profile, first register through MarathiVadhuVarSuchak.com Marathi matrimony."
                },
                {
                  question: "How to search Dhangar Vadhu Var Suchak grooms online?",
                  answer: "To search Dhangar Vadhu Var Suchak grooms online, Dhangar Samaj brides first need to register free though MarathiVadhuVarSuchak.com Marathi matrimony site or app."
                },
                {
                  question: "How to download Dhangar Vadhu list PDF online?",
                  answer: "After free registration through MarathiVadhuVarSuchak.com Marathi matrimony, Dhangar Samaj Var can see a list of Vadhu profiles with photos."
                },
                {
                  question: "How to find Dhangar Vadhu Var Jejuri location?",
                  answer: "MarathiVadhuVarSuchak.com Dhangar matrimony provides a list of profiles from different locations in Maharashtra state including Jejuri."
                },
                {
                  question: "How to search Dhangar Vadhu Var contact number?",
                  answer: "MarathiVadhuVarSuchak.com matrimony registered members can get Dhangar Vadhu Var contact numbers."
                },
                {
                  question: "How to get the Dhangar Vadhu list online?",
                  answer: "To get Dhangar Vadhu list online first register for free through MarathiVadhuVarSuchak.com matrimony site or mobile app."
                },
                {
                  question: "How to join Dhangar Var Vadhu whatsapp group?",
                  answer: "No! MarathiVadhuVarSuchak.com matrimony privacy policy does not allow joining whatsapp groups."
                },
                {
                  question: "How to join Dhangar Var Vadhu whatsapp group link?",
                  answer: "MarathiVadhuVarSuchak.com matrimony does not have any whatsapp group to join due to privacy policy of the members."
                },
                {
                  question: "How to search verified Dhangar Var Vadhu Photos with profile?",
                  answer: "Visit MarathiVadhuVarSuchak.com matrimony for free registration, after approval users can search Dhangar Var Vadhu Photos with profile."
                },
                {
                  question: "How to search for a Dhangar Vadhu list girl online?",
                  answer: "Through MarathiVadhuVarSuchak.com matrimony, registered members can search the Dhangar Vadhu list online."
                },
                {
                  question: "How to search Dhangar Var Vadhu contact number online?",
                  answer: "To search Dhangar Var Vadhu contact number online, first register on MarathiVadhuVarSuchak.com matrimony."
                },
                {
                  question: "How to search Dhangar grooms photos with full profile?",
                  answer: "Visit MarathiVadhuVarSuchak.com matrimony for free registration. After profile verification users can search Dhangar grooms photos with full profile."
                },
                {
                  question: "How to join Dhangar grooms whatsapp group online?",
                  answer: "As per MarathiVadhuVarSuchak.com matrimony privacy policy, we do not have any whatsapp group to join."
                },
                {
                  question: "How to join Dhangar grooms whatsapp group link?",
                  answer: "As per privacy policy for MarathiVadhuVarSuchak.com matrimony, there is no Whatsapp group to join."
                },
                {
                  question: "How to search Dhangar Grooms Maharashtra online?",
                  answer: "To search Dhangar Grooms Maharashtra online first you need to register free on MarathiVadhuVarSuchak.com matrimony site."
                },
                {
                  question: "How to search Dhangar grooms contact number online?",
                  answer: "To search Dhangar grooms contact number online you have to register free through MarathiVadhuVarSuchak.com."
                },
                {
                  question: "How to search Divorced Dhangar grooms online?",
                  answer: "To search Divorced Dhangar grooms online brides have to register free through MarathiVadhuVarSuchak.com."
                },
                {
                  question: "How to search Dhangar Brides list online?",
                  answer: "To search Dhangar Brides list online first register free on MarathiVadhuVarSuchak.com matrimony."
                },
                {
                  question: "How can Dhangar Var list Hatkar list be searched?",
                  answer: "For Dhangar Var list Hatkar list search first register through MarathiVadhuVarSuchak.com matrimony site or mobile app."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Dhangar Matrimony for Marathi Communities"
        items={communityServices}
      />

    </div>
  );
}
